import { Paper, Stack, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Dayjs } from "dayjs";
import UsersFilterItems from "./UsersFilterItems";

interface UsersFilterCardProps {
  dateRange: [Dayjs | null, Dayjs | null];
  onDateRangeChange: (range: [Dayjs | null, Dayjs | null]) => void;
}

export default function UsersFilterCard({ dateRange, onDateRangeChange }: UsersFilterCardProps) {
  return (
    <Paper
      variant="outlined"
      sx={{
        p: "18px 22px",
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: 2.25,
        borderColor: "#ececec",
      }}
    >
      <UsersFilterItems dateRange={dateRange} onDateRangeChange={onDateRangeChange} />
      <Stack
        direction="row"
        spacing={0.75}
        alignItems="center"
        sx={{ ml: "auto", color: "#9e9e9e" }}
      >
        <InfoOutlinedIcon fontSize="small" sx={{ color: "#8E24AA", fontSize: 16 }} />
        <Typography variant="caption" sx={{ fontSize: 13 }}>
          Applicant funnel - powered by BQL
        </Typography>
      </Stack>
    </Paper>
  );
}
